import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatTabsModule } from '@angular/material/tabs';
import { I18NextModule } from 'angular-i18next';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkTableModule } from '@angular/cdk/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {MatProgressBarModule} from '@angular/material/progress-bar';

// Real-Time Overview Components
import { RealTimeOverviewComponent } from './real-time-overview/real-time-overview.component';
import { RealTimeOverviewQueueComponent } from './real-time-overview/queue/real-time-overview-queue.component';
import { RealTimeOverviewAgentComponent } from './real-time-overview/agent/real-time-overview-agent.component';
import { RealTimeOverviewSchedComponent } from './real-time-overview/sched/real-time-overview-sched.component';

// User Groups Components
import { UserGroupsComponent } from './user-groups/user-groups.component';
import { UserGroupsGetgroupComponent } from './user-groups/getgroup/user-groups-getgroup.component';

// Ticker Services Components
import { TickerServicesComponent } from './ticker-services/ticker-services.component';

// Ticker Queues Components
import { TickerQueuesComponent } from './ticker-queues/ticker-queues.component';

// Ticker User Groups Components
import { TickerUserGroupsComponent } from './ticker-user-groups/ticker-user-groups.component';
import { TickerUserGroupsGetComponent } from './ticker-user-groups/get/ticker-user-groups-get.component';
import { TickerAgentComponent } from './ticker-user-groups/ticker-agent/ticker-agent.component';

// Ongoing Requests Components
import { OngoingRequestsComponent } from './ongoing-requests/ongoing-requests.component';

// Wallboard Components
import { WallboardComponent } from './wallboard/wallboard.component';
import { WallboardSettingsComponent } from './wallboard/settings/wallboard-settings.component';

//Dialog Components
import { AlarmDialogComponent } from './real-time-dialogs/alarm-dialog/alarm-dialog.component';
import { SystemQueueDialogComponent } from './real-time-dialogs/system-queue-dialog/system-queue-dialog.component';
import { AgentsStatusDialogComponent } from './real-time-dialogs/agents-status-dialog/agents-status-dialog.component';
import { ProfileDialogComponent } from './real-time-dialogs/profile-dialog/profile-dialog.component';
import { SetPauseDialogComponent } from './real-time-dialogs/set-pause-dialog/set-pause-dialog.component';
import { ChangeReservedAgentDialogComponent } from './real-time-dialogs/change-reserved-agent-dialog/change-reserved-agent-dialog.component';
import { PreviewRequestDialogComponent } from './real-time-dialogs/preview-request-dialog/preview-request-dialog.component';
import { SetLogOnDialogComponent } from './real-time-dialogs/set-logOn-dialog/set-logOn-dialog.component';
import { ClockComponent } from './realtime-clock/clock.component';
import { DashboardModule } from '../dashboards/dashboard.module';
import { LazyElementDirective } from "@angular-extensions/elements";

@NgModule({
  declarations: [
    // Real-Time Overview
    RealTimeOverviewComponent,
    RealTimeOverviewQueueComponent,
    RealTimeOverviewAgentComponent,
    RealTimeOverviewSchedComponent,

    // User Groups
    UserGroupsComponent,
    UserGroupsGetgroupComponent,

    // Ticker Services
    TickerServicesComponent,

    // Ticker Queues
    TickerQueuesComponent,

    // Ticker User Groups
    TickerUserGroupsComponent,
    TickerUserGroupsGetComponent,
    TickerAgentComponent,

    // Ongoing Requests
    OngoingRequestsComponent,

    // Wallboard
    WallboardComponent,
    WallboardSettingsComponent,

    // Dialogs
    AlarmDialogComponent,
    SystemQueueDialogComponent,
    AgentsStatusDialogComponent,
    ProfileDialogComponent,
    SetPauseDialogComponent,
    ChangeReservedAgentDialogComponent,
    PreviewRequestDialogComponent,
    SetLogOnDialogComponent,
    ClockComponent
  ],
  imports: [
    DashboardModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    CdkTableModule,
    MatChipsModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SharedModule,
    NgSelectModule,
    RouterModule,
    DragDropModule,
    MatProgressBarModule,
    I18NextModule.forRoot(),
    LazyElementDirective
],
  exports: [
    RealTimeOverviewComponent,
    UserGroupsComponent,
    TickerServicesComponent,
    TickerQueuesComponent,
    TickerUserGroupsComponent,
    TickerAgentComponent,
    OngoingRequestsComponent,
    WallboardComponent
  ]
})
export class RealTimeModule { }
